export const CREATE_ADMINISTRATOR = 'administrators/create';
export const RETRIEVE_ADMINISTRATORS = 'administrators/retrieve';
export const RETRIEVE_ADMINISTRATOR = 'administrators/getById';
export const UPDATE_ADMINISTRATOR = 'administrators/update';
